export default __webpack_public_path__ + "static/media/document-upload-failure-dark.c71b6010.png";